import { render, staticRenderFns } from "./EventGroupForm.vue?vue&type=template&id=0768600e"
import script from "./EventGroupForm.vue?vue&type=script&lang=js"
export * from "./EventGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports